// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Cq0eZ","content":"styles_content__2fSNH","row":"styles_row__3r1Ew","footer":"styles_footer__2CQF4","phraseLength":"styles_phraseLength__3Fzbe"};